import { getUrlParamValue } from "../getUrlParamValue";
const DEFAULT_QUANTITY = "1";
const SINGLE_PACKS_QUANTITY_LIMIT = 5;
const CARTONS_QUANTITY_LIMIT = 3;
export const getInitialQuantity = (packagingPreference) => {
    const urlParamQuantityValue = Number(getUrlParamValue("quantity"));
    if (!urlParamQuantityValue)
        return DEFAULT_QUANTITY;
    const limit = packagingPreference === "single_packs" ? SINGLE_PACKS_QUANTITY_LIMIT : CARTONS_QUANTITY_LIMIT;
    return urlParamQuantityValue > limit ? limit.toString() : urlParamQuantityValue.toString();
};
//# sourceMappingURL=getInitialQuantity.js.map